import * as t from './endpoints';
import {
  AllAnalysisData,
  summaryApiParam,
  AnalysisPensionScheme,
  AnalysisParamWithFilter,
  FundAnalysisParam,
  FundCost,
  Paginated
} from './types';
import { AxiosResponse } from 'axios';
import { HTTPServiceClient } from '@/packages/http/service';
import OrganisationType from '../../models/OrganisationType';
import Investment from '../../models/Investment';
import Organisation from '../../models/Organisation';
import TimePeriod from '../../models/TimePeriod';
import { Fund, OrganisationManager, OrgFundsRequest } from '../fund/types';

/**
 * --------------------------------------------------
 *	Cost Analysis HTTP Serice
 * --------------------------------------------------
 **/
export const CostAnalysisService = {
  getAnalysisByFilter(
    params: AnalysisParamWithFilter
  ): Promise<AllAnalysisData | AxiosResponse<boolean>> {
    return HTTPServiceClient.get(t.GET_ANALYSIS_BY_ORG_ID(params))
      .then(({ data }) => data)
      .catch(error => {
        return null;
      });
  },

  getFundAnalysis(params: FundAnalysisParam): Promise<Paginated<FundCost>> {
    return HTTPServiceClient.get(t.GET_FUND_ANALYSIS(params))
      .then(({ data }) => data)
      .catch(error => {
        return null;
      });
  },

  getAllFundsByFilter(params: OrgFundsRequest): Promise<Paginated<Fund>> {
    return HTTPServiceClient.get(t.GET_ALL_FUNDS_BY_FILTER(params))
      .then(({ data }) => data)
      .catch(error => {
        return null;
      });
  },

  async getSummary(params: summaryApiParam): Promise<AllAnalysisData> {
    const { data } = await HTTPServiceClient.get(t.FETCH_COST_SUMMARY(params));
    return data;
  },

  getAllOrganisationTypes(): Promise<OrganisationType[]> {
    return HTTPServiceClient.get(t.GET_ALL_ORGANISATION_TYPES).then(
      ({ data }) => data.data
    );
  },

  getAllInvestments(): Promise<Investment[]> {
    return HTTPServiceClient.get(t.GET_ALL_INVESTMENTS).then(
      ({ data }) => data.data
    );
  },

  getAllAssetClasses(params: any): Promise<OrganisationType[]> {
    return HTTPServiceClient.get(t.GET_ALL_ASSET_CLASSES({})).then(
      ({ data }) => data.data
    );
  },
  getAllOrganisations(params: any): Promise<Organisation[]> {
    return HTTPServiceClient.get(t.GET_ALL_ORGANISATIONS({})).then(
      ({ data }) => data.data
    );
  },

  getOrganisationWithChildren(params: any): Promise<Organisation[]> {
    return HTTPServiceClient.get(t.GET_ORGANISATION_WITH_CHILDREN(params)).then(
      ({ data }) => data.data
    );
  },

  getAllFundByOrganisationId(params: any): Promise<Fund[]> {
    return HTTPServiceClient.get(
      t.GET_ALL_FUNDS_BY_ORGANISATION_ID(params)
    ).then(({ data }) => data.data);
  },
  getAllTimePeriods(params: any): Promise<TimePeriod[]> {
    return HTTPServiceClient.get(t.GET_ALL_TIME_PERIODS({})).then(
      ({ data }) => data.data
    );
  },

  async getExposedFunds(orgId: string): Promise<Fund[]> {
    return await HTTPServiceClient.get(
      t.GET_EXPOSED_ORGANIZATION_FUNDS(orgId)
    ).then(({ data }) => data.data);
  },

  async getExposedPensionSchemes(
    orgId: string
  ): Promise<AnalysisPensionScheme[]> {
    const { data } = await HTTPServiceClient.get(
      t.GET_EXPOSED_PENSION_SCHEMES(orgId)
    );
    return data.data;
  },

  async getOrganizationManagers(orgId: string): Promise<OrganisationManager[]> {
    const { data } = await HTTPServiceClient.get(
      t.GET_ORGANISATION_MANAGERS(orgId)
    );
    return data.data;
  }
};
